import { z } from 'zod';
export const isUserRegisteredPathSchema = z.object({
    subdomain: z.string(),
});
export const isUserRegisteredQuerySchema = z.object({
    tradingCompetitionId: z.string(),
});
export const isUserRegisteredOutputSchema = z.object({
    isRegistered: z.boolean(),
});
